var TodoDataTestIds = /* @__PURE__ */ ((TodoDataTestIds2) => {
  TodoDataTestIds2["ListContainer"] = "todo-list-container";
  TodoDataTestIds2["LastTodoCardContainer"] = "last-todo-card-container";
  TodoDataTestIds2["TodoCard"] = "todo-card";
  TodoDataTestIds2["TodoStatusContainer"] = "todo-status-container";
  TodoDataTestIds2["TodoStatus"] = "todo-status";
  TodoDataTestIds2["TodoStatusLabel"] = "todo-status-label";
  TodoDataTestIds2["TodoStatusArrow"] = "todo-status-arrow";
  TodoDataTestIds2["TodoStatusComment"] = "todo-status-comment";
  TodoDataTestIds2["TodoStatusMenu"] = "todo-status-menu";
  TodoDataTestIds2["TodoStatusOptions"] = "todo-status-options";
  TodoDataTestIds2["TodoStatusMenuOptionIgnore"] = "todo-status-menu-option-ignore";
  TodoDataTestIds2["TodoStatusMenuOptionRecall"] = "todo-status-menu-option-recall";
  TodoDataTestIds2["TodoStatusMenuOptionDone"] = "todo-status-menu-option-done";
  TodoDataTestIds2["TodoIgnoreCommentField"] = "todo-ignore-comment-field";
  TodoDataTestIds2["TodoDetailsModal"] = "todo-details-modal";
  TodoDataTestIds2["TodoModalRowCategory"] = "todo-modal-row-category";
  TodoDataTestIds2["TodoModalRowDescription"] = "todo-modal-row-description";
  TodoDataTestIds2["TodoModalRowPatientExternalId"] = "todo-modal-row-patient-external-id";
  TodoDataTestIds2["TodoModalCellCategory"] = "todo-modal-cell-category";
  TodoDataTestIds2["TodoModalCellCreatedAt"] = "todo-modal-cell-created-at";
  TodoDataTestIds2["TodoModalRowPatient"] = "todo-modal-row-patient";
  TodoDataTestIds2["TodoModalCellPatientName"] = "todo-modal-cell-patient-name";
  TodoDataTestIds2["TodoModalCellPatientDetails"] = "todo-modal-cell-patient-details";
  TodoDataTestIds2["TodoModalRowAppointmentTitle"] = "todo-modal-row-appointment-title";
  TodoDataTestIds2["TodoModalRowAppointmentDetails"] = "todo-modal-row-appointment-details";
  TodoDataTestIds2["TodoModalRowPractitioner"] = "todo-modal-row-practitioners";
  TodoDataTestIds2["TodoModalRowCancellationReason"] = "todo-modal-row-cancellation-reason";
  TodoDataTestIds2["TodoModalRowDueDateComment"] = "todo-modal-row-due-date-comment";
  TodoDataTestIds2["TodoModalRowDueDate"] = "todo-modal-row-due-date";
  TodoDataTestIds2["TodoModalFooter"] = "todo-modal-footer";
  TodoDataTestIds2["TodoModalCallPatientButton"] = "todo-modal-call-patient-button";
  TodoDataTestIds2["TodoModalOpenInCalendarButton"] = "todo-modal-open-in-calendar-button";
  return TodoDataTestIds2;
})(TodoDataTestIds || {});
export {
  TodoDataTestIds
};
